import { memo } from 'react';
import { Control, FieldPath, FieldValues, useController, useFormContext } from 'react-hook-form';
import { StartDatePicker } from './StartDatePicker';

type StartDatePickerProps = React.ComponentProps<typeof StartDatePicker>;

type RHFStartDatePickerProps<TFieldValues extends FieldValues = FieldValues> = Omit<
  StartDatePickerProps,
  'input'
> & {
  name: FieldPath<TFieldValues>;
  control?: Control<TFieldValues>;
};

const RHFStartDatePickerInner = <TFieldValues extends FieldValues = FieldValues>({
  name,
  control: controlProp,
  ...props
}: RHFStartDatePickerProps<TFieldValues>) => {
  const formContext = useFormContext<TFieldValues>();
  const control = controlProp ?? formContext?.control;

  const { field } = useController({ name, control });

  return <StartDatePicker {...props} input={field} />;
};

export const RHFStartDatePicker = memo(RHFStartDatePickerInner) as typeof RHFStartDatePickerInner;
